const styles = {
  root: {
    display: 'flex',
    textAlign: 'center',
    justifyContent: 'left',
    mr: 2,
  },

  searchBar: {
    '&.MuiTextField-root.Mui-style .MuiOutlinedInput-root': {
      height: '40px',
      borderRadius: { xs: '4px 0px 0px 4px!important', md: '4px 4px 4px 4px!important' },
      pr: '0!important',
    },
    '&.MuiTextField-root.Mui-style .MuiOutlinedInput-root:selected': {
      pr: '0!important',
    },
  },

  searchIcon: {
    cursor: 'pointer!important',
    borderRadius: '100%',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'background.secondary',
    },
  },

  btn: {
    height: '40px',
  },

  contentController: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  inputLabel: {
    paddingBottom: 1,
    '&:not(:first-of-type)': {
      paddingTop: 2,
    },

  },

  inputAdornment: {
    height: '100%',
    mr: 1,
    '&.selected': {
      mr: '0!important',
      '& svg': {
        transition: 'all 0.3s easy',
        backgroundColor: '#20c1e7',
        color: 'text.white',
        borderRadius: 0,
        width: 40,
        height: 40,
        p: 1,
      },
    },
  },

}

export default styles
